import { secondaryPackagingRequest } from '@/request'
interface funResult {
	code?: number;
	data?: any;
	message?: any;
}
//获取角色列表
export const getRoleList = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/role/list',
    params,
    isLoading: false,
    needToken: true,
})
//获取所有的角色
export const roleAll = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/role/all',
    isLoading: false,
    needToken: true
})
//新增角色
export const roleSave = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/role/save',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改角色
export const roleUpdate = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/role/update',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//删除角色
export const roleDelete = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/role/delete',
    method: 'POST',
    params,
    isLoading: false,
    needToken: true
})
//启用角色
export const roleEnable = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/enable',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    params,
    isLoading: false,
    needToken: true
})
//禁用角色
export const roleDisable = (params:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/user/disable',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    params,
    isLoading: false,
    needToken: true
})
//禁用角色
export const menuList = (params?:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/auth/menuList',
    params,
    isLoading: false,
    needToken: true
})